import React, {useCallback, useEffect, useState} from 'react';
import {useLocation, useNavigate} from "react-router";
import {callAlertWeb, callNativeWeb, clickMoveToAppWeb, footerShowEventWeb} from "common/appInterface";
import {Location} from "history";
import {useTranslation} from "react-i18next";
import client from "lib/CommonApi/client";
import {AxiosError} from "axios";
import {inquiryFunctionAppVersion} from "../../api/SelfCommonAPI";
import NonInoutInfo from "views/CardManage/NonInoutInfo";

const CardPendingFeeView: React.FC = () => {
    /** Location State */
    const location = useLocation() as Location<LocationState>;
    /** Navigate */
    const navigate = useNavigate();
    /** 다국어처리 */
    const {t, i18n} = useTranslation();

    const screenId = 'SERV18';
    const screenName = t('SERV18.title');

    const cardInfo: CardInfo = location.state.info;

    const [payPendingFeeVersion, setPayPendingFeeVersion] = useState<number | null>(null);
    const [monthlyFeeHistory, setMonthlyFeeHistory] = useState<Array<MonthlyFeeHistory>>(location.state.storage?.monthlyFeeHistory || []);
    const [nonInoutTotalBalance, setNonInoutTotalBalance] = useState<number>(location.state.storage?.nonInoutTotalBalance || 0);
    const [nonInoutInfoDetail, setNonInoutInfoDetail] = useState<Array<NonInoutInfoDetail>>(location.state.storage?.nonInoutInfoDetail || []);

    /** 뒤로가기 처리 (backKeyEvent_App (APP > WEB)) */
    const callbackBackkeyEvent = useCallback(() => {
        if (location.state.linkOpenMenu === 'main') {
            navigate("/main", {
                state: {
                    query: location.state.query
                    , swiperIndex: location.state.swiperIndex
                    , tabIndex: location.state.tabIndex
                    , from: location.pathname
                }
            });
        } else {
            navigate(-1);
        }
    }, [navigate, location.state.linkOpenMenu, location.state.query, location.state.swiperIndex, location.state.tabIndex, location.pathname]);

    /**
     * dhbyun
     * CARD_PAY_PENDING_FEE 조회
     */
    const inquiryFunctionAppVersionApi = useCallback(
        async () => {
            await inquiryFunctionAppVersion("CARD_PAY_PENDING_FEE", location)
                .then((res) => {
                    if (res.data.resData) {
                        setPayPendingFeeVersion(res.data.resData.version);
                    }
                }).catch((e: AxiosError) => {
                    callAlertWeb("ERROR", "99", e.message);
                });
        },
        [location]
    );

    /** 월회비납부내역조회 */
    const callMonthlyFeeHistory = useCallback(async () => {
            await client.get('/api/app/manage/monthlyFee/history', {
                params: {
                    ...location.state.query,
                    alternativeCardNo: cardInfo.alternativeCardNo
                }
            }).then(response => {
                setMonthlyFeeHistory(response.data.response || []);
            }).catch((e: AxiosError) => {
                callAlertWeb('ERROR', '99', e.message);
            });
        },
        [cardInfo, location.state.query]
    );

    /** 미납항목조회 */
    const callNonInoutInfo = useCallback(async () => {
            await client.get('/api/app/manage/nonInout/info', {
                params: {
                    ...location.state.query
                }
            }).then(response => {
                setNonInoutTotalBalance(Number(response.data.response?.totalBalance) || 0);
                setNonInoutInfoDetail(response.data.response?.detail || []);
            }).catch((e: AxiosError) => {
                callAlertWeb('ERROR', '99', e.message);
            });
        },
        [location.state.query]
    );

    // 최초실행
    useEffect(() => {
        // 언어설정
        i18n.changeLanguage(location.state.query.languageCode);
        // callNative_Web 처리 (WEB > APP)
        callNativeWeb(screenId, screenName, location.state.from === '/intro' ? 'Y' : 'N');
        // 하단바 숨기기
        footerShowEventWeb('N');

        console.log("QUERY STATE");
        console.log(location.state);

        inquiryFunctionAppVersionApi();
        callMonthlyFeeHistory();
        callNonInoutInfo();

        // 최초한번실행 useEffect() Warning 제거
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // 뒤로가기 이벤트 리스너 (backKeyEvent_App (APP > WEB))
    useEffect(() => {
        document.addEventListener('backpress', callbackBackkeyEvent);
        return () => document.removeEventListener('backpress', callbackBackkeyEvent);
    }, [callbackBackkeyEvent]);

    useEffect(() => {
        if (location.state.storage) {
            location.state.storage.nonInoutTotalBalance = nonInoutTotalBalance;
            location.state.storage.nonInoutInfoDetail = nonInoutInfoDetail;
        }
    }, [location.state.storage, nonInoutTotalBalance, nonInoutInfoDetail]);

    useEffect(() => {
        if (location.state.storage) {
            location.state.storage.monthlyFeeHistory = monthlyFeeHistory;
        }
    }, [location.state.storage, monthlyFeeHistory]);

    return (
        <div id="wrap" className='pdb70'>
            <div id='container' className='pcHidden'>
                <section className='contents monthlyFeePaymentDetail'>
                    <div className="inner">
                        {(nonInoutTotalBalance > 0 && nonInoutInfoDetail.length > 0) && (
                            <section>
                                <div>
                                    <div className='Please-pay-Pending-Fee'>
                                        <span>{t('SERV18.explan01')}</span>
                                    </div>
                                    <NonInoutInfo callNonInoutInfo={callNonInoutInfo} nonInoutTotalBalance={nonInoutTotalBalance}
                                                  nonInoutInfoDetail={nonInoutInfoDetail} />
                                </div>
                            </section>
                        )}
                    </div>
                </section>
                <div className="btnArea">
                    <div className="btnWrapTy01">
                        {
                            ((location.state.query.apiVersion != null && payPendingFeeVersion != null) &&
                                (parseInt(location.state.query.apiVersion) >= payPendingFeeVersion!) &&
                                (nonInoutTotalBalance !== 0 || monthlyFeeHistory.findIndex((value: MonthlyFeeHistory) =>
                                        value.monthlyFeeExemptionCode !== '1' && value.inoutProcessCode === '2') !== -1
                                )
                            )
                                ? (
                                    <button type="button" className="btnPrimaryTy01"
                                            disabled={(location.state.query.apiVersion == null || payPendingFeeVersion == null)
                                                || (parseInt(location.state.query.apiVersion) < payPendingFeeVersion!)}
                                            onClick={() => clickMoveToAppWeb("N039")}
                                    >
                                        <span>{t("SERV18.button.pay")}</span>
                                    </button>
                                ) : (
                                    <button type="button" className="btnPrimaryTy01"
                                            onClick={callbackBackkeyEvent}
                                    >
                                        <span>{t("COMMON.button.done")}</span>
                                    </button>
                                )
                        }
                    </div>
                </div>
            </div>
        </div>
    )
        ;
};

export default CardPendingFeeView;
